module.exports = __webpack_public_path__ + "static/media/island-tropical.2114d18a.svg";